type SAMLAuthErrorCodeLiterals =
  | "bad_request.invalid_saml_relay_state"
  | "bad_request.saml_auth_user_not_found"
  | "bad_request.saml_assertion_err"
  | "forbidden.not_permitted_network_access";

type SAMLAuthErrorMessage = {
  [key in SAMLAuthErrorCodeLiterals]: string;
};

const SAML_ERROR_MESSAGE: SAMLAuthErrorMessage = {
  "bad_request.invalid_saml_relay_state":
    "RelayStateが不正です。システム管理者へご連絡ください。",
  "bad_request.saml_auth_user_not_found":
    "ユーザーが作成されていません。システム管理者へご連絡ください。",
  "bad_request.saml_assertion_err":
    "SAML認証エラーが発生しました。システム管理者へご連絡ください。",
  "forbidden.not_permitted_network_access":
    "ご利用中のネットワークからのアクセスが許可されていません。",
};

export const resolveSAMLErrorMessage = (errCode: string): string => {
  if (errCode in SAML_ERROR_MESSAGE) {
    return SAML_ERROR_MESSAGE[errCode as SAMLAuthErrorCodeLiterals];
  }
  return "システムエラーが発生しました。システム管理者へご連絡ください。";
};
